import React, { useEffect } from "react";
import "./pushnotification.scss";
import logo from "../../assets/images/clubmav-logo.png";
import { IoClose } from "react-icons/io5";
import { Tooltip } from "@mui/material";

const PushNotification = ({ title, body, onClose, onClick }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  useEffect(() => {
    try {
      const audio = new Audio("/sounds/message.wav");
      audio.play().catch((error) => console.error("Error playing notification sound:", error));
    } catch (error) {
      console.error("Error creating audio object:", error);
    }
  }, []);
  const userData = localStorage.getItem("user")
    ? JSON.parse(localStorage["user"])
    : "";

  const companyColor = userData?.company_color;

  return (
    <section
      className="pushnotifca"
      onClick={() => {
        if (onClick) onClick();
        else onClose();
      }}
      style={{ cursor: "pointer" }}
    >
      <div
        className="notify"
        style={{ borderLeft: `4px solid ${companyColor}` }}
      >
        <img src={logo} alt="icon" style={{ width: "86px" }} />
        <div className="notify-content">
          <h4 className="notify-title">{title}</h4>
          <Tooltip
            title={body}
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#fff",
                  color: "#333",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  fontSize: "12px",
                  maxWidth: 300,
                  lineHeight: 1.5,
                  padding: "10px",
                  "& .MuiTooltip-arrow": {
                    color: "#fff",
                  },
                },
              },
              popper: {
                sx: {
                  zIndex: 99999,
                },
              },
            }}
          >
            <p className="notify-body">{body}</p>
          </Tooltip>
        </div>
        <button
          className="notify-close"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <IoClose />
        </button>
      </div>
    </section>
  );
};

export default PushNotification;
